
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import VirtualRedTagHeader from '@/components/VirtualRedTag/VirtualRedTagHeader.vue';
import VirtualRedTagMethodIcon from '@/components/VirtualRedTag/VirtualRedTagMethodIcon.vue';
import virtualRedTagNotificationFlow from '@/shared/mixins/virtualRedTagNotificationFlow';
import {
    VirtualRedTagNotificationChannel,
    VirtualRedTagNotificationRoute,
} from '@/types/VirtualRedTagNotification';

export default defineComponent({
    name: 'VirtualRedTagNotificationMethod',
    components: {
        FbxButton,
        VirtualRedTagHeader,
        VirtualRedTagMethodIcon,
    },
    mixins: [virtualRedTagNotificationFlow],
    computed: {
        NotificationMethod(): typeof VirtualRedTagNotificationChannel {
            return VirtualRedTagNotificationChannel;
        },
    },
    methods: {
        chooseMethod(method: VirtualRedTagNotificationChannel): void {
            this.$router.push({
                name: VirtualRedTagNotificationRoute.contact,
                params: { trailerNumber: this.trailerNumber },
                query: this.notificationQuery(method),
            });
        },
        navigateToWelcome(): void {
            this.$router.push({ name: 'VirtualRedTagEntry' });
        },
    },
});
